export const UserRoleWildcard = {
  ANY_ROLE: "ANY_ROLE",
} as const;

export type UserRoleWildcard =
  (typeof UserRoleWildcard)[keyof typeof UserRoleWildcard];
